type Navigate = (path: string, opts?: { replace?: boolean }) => void;

let navigateImpl: Navigate | null = null;

// Conectado una sola vez por <NavigationBridge/> (ver App.tsx) — permite
// navegar desde fuera de componentes React (lib/api.ts, al interceptar un
// 403) sin recurrir a window.location (que recargaría toda la app).
export function setNavigate(fn: Navigate): void {
  navigateImpl = fn;
}

export function navigateTo(path: string, opts?: { replace?: boolean }): void {
  if (navigateImpl) {
    navigateImpl(path, opts);
  } else {
    window.location.assign(path);
  }
}
